<!-- 配件询价历史 -->
<template>
    <div v-loading="loading">
        <div class="apig-table-ctn table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%">
                <el-table-column min-width="160px" prop="StorageName" label="仓库" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="160px" prop="ShelfSpaceCode" label="仓位" show-overflow-tooltip></el-table-column>
                <el-table-column width="120px" prop="SpaceType" label="仓位类型" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" key="op">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="norecommend(scope.row.SpaceId)" style="color: red" v-if="scope.row.UnRecState == 0">不再推荐</el-button>
                        <el-button type="text" size="mini" @click="recoverRe(scope.row.SpaceId)" v-if="scope.row.UnRecState == 1">恢复推荐</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        EntpTempGoodsId: {
            type: String
        }
    },
    data() {
        return {
            loading: false,
            searchData: {
                GoodsId: this.EntpTempGoodsId,
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0
        };
    },
    mounted() {
        if (this.searchData.GoodsId) this.getTableData();
    },
    methods: {
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEntpGoodsPositionHisDatas',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        norecommend(spaceId) {
            if (spaceId) {
                let that = this;
                this.$util.elConfirm({
                    content: '确定要去掉该历史仓位的推荐吗?',
                    noMsg: true,
                    confirm() {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpGoods/NoRecommendPartSpace?spaceId=${spaceId}`
                            })
                            .then(() => {
                                that.$util.successMsg('成功去掉该历史仓位的推荐');
                                that.getTableData();
                            })
                            .catch(() => {});
                    }
                });
            }
        },
        recoverRe(spaceId) {
            if (spaceId) {
                let that = this;
                this.$util.elConfirm({
                    content: '确定要恢复该历史仓位的推荐吗?',
                    noMsg: true,
                    confirm() {
                        that.$util
                            .axiosPost({
                                url: `/api/EntpGoods/RecRecommendPartSpace?spaceId=${spaceId}`
                            })
                            .then(() => {
                                that.$util.successMsg('成功恢复该历史仓位的推荐');
                                that.getTableData();
                            })
                            .catch(() => {});
                    }
                });
            }
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn {
    margin-top: 5px;
}
.data-count {
    padding: 5px;
    display: flex;
    flex-direction: row-reverse;
}
.data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 12.5%;
    border-left: 1px solid @border4Color;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
        margin-bottom: 5px;
    }
}
</style>
<style lang="less">
.apig-table-ctn {
    .el-table {
        margin-bottom: 5px;
        margin-top: 15px;
    }
}
</style>
